<!--
    主页面-头部
    功能：主页面-头部，退出登录、切换校区
-->
<script>
/**
 * @overview 主页面 - 头部
 */

import { passwordModify } from '../components';
import baseUrl from '../../utils/api';
import defaultMan from '@/assets/images/staff_man.png';
import defaultWomen from '@/assets/images/staff_women.png';

export default {
  name: 'MainHeader',
  inject: ['reload'],
  data() {
    return {
      moveErrorMan: `this.src="${defaultMan}"`,
      moveErrorWomen: `this.src="${defaultWomen}"`,
      options: [],
      value: '',
      userInfo: '',
    };
  },
  computed: {
    school() {
      return this.$store.state.school;
    },
    choicesSchool() {
      return this.$store.state.choicesSchool;
    },
    user() {
      return this.$store.state.mainUser;
    },
  },
  watch: {
    user(val) {
      this.userInfo = this.user;
    },
  },
  created() {
    this.options = this.school;
    this.value = this.choicesSchool.name;
    this.userInfo = this.$store.state.mainUser;
  },
  methods: {
    changeDepartment(val) {
      this.options.forEach((item) => {
        if (item.id === val) {
          this.$http.get(`${this.$checkHttp()}${item.domain}/api/user`)
            .then((res) => {
              if (res.status === 2) {
                this.$message.error('当前校区已被禁用，请重新选择！');
                setTimeout(() => {
                  this.reload();
                }, 2000);
              } else {
                localStorage.setItem('choicesSchool', JSON.stringify(item));
                this.$store.commit('setApiUrl', `${this.$checkHttp()}${item.domain}`); // 设置切换校区api地址
                this.$store.commit('setChoicesSchool', item); // 设置选择的校区
                this.$store.commit('initUser', res); // 初始化用户信息
                // this.$store.dispatch('initUserRole'); // 初始化角色列表
                // this.$store.dispatch('initGrade'); // 初始化年级列表
                this.reload();
              }
            })
            .catch((err) => {
              this.$message.error(err.message);
            });
        }
      });
    },
    preLogout() {
      this.$alert('确定退出登录？', {
        showCancelButton: true,
        type: 'warning',
      }).then(this.logout);
    },

    logout() {
      this.$token.remove();
      localStorage.removeItem('choicesSchool');
      window.location.href = `${baseUrl}/sso/logout?client_id=4&redirect_uri=${window.location.origin}&response_type=token&scope=&state=4`;
    },
    preModifyPassword() {
      passwordModify.open();
    },
  },
};
</script>

<template>
  <div class="main-header">
    <!--    <el-tag type="warning" class="tag">-->
    <!--      <i class="el-icon-warning"></i>-->
    <!--      平台使用仅剩5天，请联系运营人员进行续费-->
    <!--    </el-tag>-->
    <div style="display: inline-block; margin-right: 15px;">
      <el-select
        v-model="value"
        size="mini"
        placeholder="切换校区"
        @change="changeDepartment">
        <el-option
          v-for="(item, index) in options"
          :key="index"
          :label="item.name"
          :value="item.id"/>
      </el-select>
    </div>
    <img
      :src="userInfo.headimgurl ? userInfo.headimgurl : ''"
      :onerror="userInfo.gender === 1 ? moveErrorMan : moveErrorWomen"
      class="head_url"
      alt="">
    <el-dropdown>
      <span class="el-draopdown-link">
        {{ userInfo.name }}
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item
          @click.native="preModifyPassword"
        >
          修改密码
        </el-dropdown-item>
        <el-dropdown-item
          @click.native="preLogout"
        >
          退出登录
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<style lang="scss" scoped>
.main-header {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 60px;
  position: relative;
  padding: 0 20px;
  background: #fff;
  box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
  .tip_span_item{
    padding-right: 2rem;
    font-size: 0.8rem;
  }
  .color_tip{
    color: red;
    font-weight: bold;
  }
  .el-dropdown {
    cursor: pointer;
    &:hover{
      span {
        color: var(--color-primary);
      }
    }
  }
  .tag {
    position: absolute;
    left: 20px;
    padding-right: 20px;
  }
  .head_url {
    width: 24px;
    height: 24px;
    display: inline-block;
    border-radius: 50%;
    margin-right: 5px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Main/Header.vue